<template>
  <Input
    :placeholder="item.caption"
    :value="form.searchText"
    name="searchText"
    id="searchText"
    type="text"
    rowClass="padding-16"
    rightIcon="magnify"
    :hasEraseIcon="!!form.searchText"
    :vuelidateObj="$v.form.searchText"
    @input="handleInput"
    @erase="handleErase"
  />
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Input } from "@/components/re-design/forms";
import { pathOr, includes } from "ramda";

export default {
  mixins: [inputMixin],
  components: { Input },
  props: {
    item: {
      type: Object,
      default: null,
    },
    selectedFilter: {
      type: String,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        searchText: {},
      },
    };
  },
  data() {
    return {
      form: {
        searchText: null,
      },
    };
  },
  watch: {
    selectedFilter: {
      immediate: true,
      handler(value) {
        if (value) {
          this.handleInput("searchText", value);
        }
      },
    },
  },
  methods: {
    pathOr,
    includes,
    handleInput(key, value) {
      this.input(key, value);
      this.generateServiceData();
    },
    handleErase() {
      this.input("searchText", null);
    },
    generateServiceData() {
      const { searchText } = this.form;
      this.$emit("getFilterData", this.item, searchText);
    },
  },
};
</script>
